import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@/components/Box';
import { UsageCategoryIcon } from '@/components/Tags/UsageCategoryTags';
import { usageCategories } from '@/shared';

import { Container, FilterProps, Label, StyledTag } from './shared';

function UsageCategories({
  searchRequestSettings,
  setSearchRequestSettings,
  label = true,
}: FilterProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div style={{ width: '100%' }}>
      {label && <Label>{t('usageCategory')}</Label>}
      <Container>
        {usageCategories.map(name => (
          <StyledTag
            key={name}
            checked={searchRequestSettings.usageCategories.includes(name)}
            onChange={checked => {
              const { usageCategories } = searchRequestSettings;
              const next = checked
                ? [...usageCategories, name]
                : usageCategories.filter(t => t !== name);
              setSearchRequestSettings({
                ...searchRequestSettings,
                usageCategories: next,
              });
            }}
            $centered
          >
            <Box flex alignItems={'center'} horizontalSpacing={1}>
              <UsageCategoryIcon usageCategory={name} />
              <div>{t(name)}</div>
            </Box>
          </StyledTag>
        ))}
      </Container>
    </div>
  );
}

export default UsageCategories;
